import React, { Suspense } from "react";
import {
  BrowserRouter,
  Routes as Switch,
  Outlet,
  Route,
} from "react-router-dom";
import routesList from "./routesList";
import { PATHS } from "../constants/paths";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import LoginShell from "../pages/Login/LoginShell";
import ForgotPassword from "../pages/Login/ForgotPassword";
import QuickLogin from "../pages/Login/QuickLogin";
import AuthenticatedGuard from "../guards/AuthenticatedGuard";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route element={<LoginShell />}>
          <Route path={PATHS.ROOT} element={<Login />} />
          <Route path={PATHS.LOGIN} element={<Login />} />
          <Route path={PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route
            path={PATHS.FORGOT_PASSWORD_VERIFY}
            element={<ForgotPassword />}
          />
          <Route
            path={PATHS.FORGOT_PASSWORD_NEW_PASSWORD}
            element={<ForgotPassword />}
          />
        </Route>
        {/* TEMP: Remove when done building - dev quick login */}
        {/* <Route
          exact
          path={PATHS.QUICK_LOGIN}
          element={
            <>
              <Suspense>
                <QuickLogin />
              </Suspense>
            </>
          }
        /> */}
        {routesList.map((route) => (
          <Route
            exact
            path={route.path}
            key="parent"
            element={route.isProtected ? <AuthenticatedGuard /> : <Outlet />}
          >
            {!route.pageExternal ? (
              <Route
                exact
                key="child"
                path={route.path}
                element={
                  <>
                    <Suspense>
                      <Home page={route.page} hideHeader={route.hideHeader} />
                    </Suspense>
                  </>
                }
              />
            ) : (
              <Route
                exact
                key="child"
                path={route.path}
                element={
                  <>
                    <Suspense>{route.page}</Suspense>
                  </>
                }
              />
            )}
          </Route>
        ))}
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
